import ClientService from '@/services/client';
import LearningTypeService from '@/services/learning-type';
import ModuleService from '@/services/module';
import ThemeService from '@/services/theme';
import useSessionStore from '@/stores/session';
import Logger from '@/utils/logger';
import $session from '@/utils/session';

export default {
  async checkAnonymousUser(to) {
    const loginSession = await $session.validateSession();

    if (!loginSession) {
      return true;
    }

    Logger.debug(`Login user: ${to.path} ---> dashboard`);
    return { name: 'dashboard' };
  },

  async checkLoginUser(to) {
    const loginSession = await $session.validateSession();

    if (loginSession) {
      return true;
    }

    Logger.debug(`Unlogged user: ${to.path} ---> /login`);
    return { name: 'login', query: to.path !== '/dashboard' ? { backward: to.path } : {} };
  },

  async checkRunningModule(to) {
    const runningModuleResult = await ModuleService.getRunningModule(useSessionStore().loginUser.id);
    const runningModule = runningModuleResult.record || null;

    if (runningModule) {
      if (to.path === '/participation') {
        useSessionStore().setHUBSettingItems({ runningModule });
        return true;
      }

      if (to.path === '/client/new') {
        return true;
      }

      // if (to.path === 'available_pages_') {
      //   return true;
      // }

      return { name: 'moduleParticipation' };
    }

    if (to.path === '/participation') {
      Logger.debug(`Invalid running module: ${to.path} ---> dashboard`);
      return { name: 'dashboard' };
    }

    return true;
  },

  async checkLearningType(to) {
    let learningTypeResult = null;

    if (to.params.learningTypeId) {
      learningTypeResult = await LearningTypeService.getLearningType(to.params.learningTypeId);
    } else if (to.params.sectorId) {
      learningTypeResult = await LearningTypeService.getLearningTypeForSector(to.params.sectorId);
    } else if (to.params.themeId) {
      learningTypeResult = await LearningTypeService.getLearningTypeForTheme(to.params.themeId);
    } else if (to.params.topicId) {
      learningTypeResult = await LearningTypeService.getLearningTypeForTopic(to.params.topicId);
    }

    const currentLearningType = learningTypeResult.record;

    if (
      currentLearningType &&
      currentLearningType.learning_type_status === 'available' &&
      Boolean(currentLearningType.is_ui_gate)
    ) {
      useSessionStore().setHUBSettingItems({
        currentFunction: {
          key: currentLearningType.learning_type_key,
          name: currentLearningType.name,
        },
        currentLearningType,
      });
      return true;
    }

    Logger.debug(`Invalid learning type: ${to.path} ---> dashboard`);
    return { name: 'dashboard' };
  },

  async checkTheme(to) {
    let themeResult = null;

    if (to.params.themeId) {
      themeResult = await ThemeService.getTheme(to.params.themeId);
    } else if (to.params.topicId) {
      themeResult = await ThemeService.getThemeForTopic(to.params.topicId);
    }

    const currentTheme = themeResult.record;

    if (currentTheme && currentTheme.theme_status === 'open') {
      useSessionStore().setHUBSettingItems({ currentTheme });
      return true;
    }

    Logger.debug(`Invalid theme: ${to.path} ---> dashboard`);
    return { name: 'dashboard' };
  },

  async checkClient(to) {
    if (to.params.clientId) {
      const clientResult = await ClientService.getClient(to.params.clientId);
      const currentClient = clientResult.record;

      if (currentClient) {
        useSessionStore().setHUBSettingItems({ currentClient });
        return true;
      }
    }

    Logger.debug(`Invalid client: ${to.path} ---> dashboard`);
    return { name: 'dashboard' };
  },

  markCurrentFunction(currentFunction) {
    useSessionStore().setHUBSettingItems({
      currentFunction,
    });
  },

  markLevelUp(levelUp) {
    useSessionStore().setHUBSettingItems({ levelUp });
  },

  resetHUBSettings() {
    useSessionStore().resetHUBSettings();
  },
};
